import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import {
  Box, Typography, Button, Tooltip,
  CircularProgress, InputAdornment, TextField, ClickAwayListener, IconButton
} from "@material-ui/core";
import { useStyles } from './styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import CancelIcon from '@material-ui/icons/Cancel';
import InfoIcon from '@material-ui/icons/Info';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import Cookies from 'js-cookie';
import ReactToPrint from 'react-to-print'
import PrintIcon from '@material-ui/icons/Print';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import MenuItem from '@material-ui/core/MenuItem';
import ErrorIcon from '@material-ui/icons/Error';

import { Calender } from "../SharedComponent/Calender";
import TermAndConditions from '../../TermAndConditions';
import { AddEditAccount } from '../SharedComponent/AddBankAccAlert';
import { checkDigitWithDecimal, renderDefaultMsg, getUserType, getAppSource, maskAccountNo, achSuspensionMessage, getLoanLabel, getFCLCompletedStatus, getChargedOffStatus, getPayOffStatus, getServiceTransferStatus, getMortgageLabel, getAccountLabel, isHEI  } from '../../../helpers';
import { FinancialHardshipAlert } from '../../FinancialHardshipAlert';
import { PROCESSING_FEE, ACCOUNT_TOOLTIP } from '../../../helpers/constants';
import moment from 'moment';
import clsx from "clsx";

import {
  getOneTimeACHPaymentDetailsQuickPay,
  getContent, getDraftOneTimePaymentQuickPay, getRecurringACHInfoQuickPay
} from '../../../actions';
import { insertActivityLogQuickPay } from '../../../actions';

import { decrypt, encrypt } from '../../../helpers/encrypt';
import { AdditionalPaymentAlert } from "../../AdditionalPaymentAlert";
import { AccountRequired } from '../SharedComponent/AccountRequired';
import { DeleteConfirmation } from '../SharedComponent/DeleteConfirmationOnBank';
import { PaymentRestrictionAlert, CutOffAlert, ServiceTransferAlert } from "../../../components";

import { Link, useHistory } from 'react-router-dom';
import { debounce } from "debounce";
import { withStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { ReviewPayment } from '../../ReviewPayment';
import spinner from '../../../assets/spinner.gif';

import clap from '../../../assets/QuickPay/clap.svg';
import checkmark from '../../../assets/checkmark.png';
import tick from '../../../assets/tick.png';
import { CustomAmountAlert } from "../SharedComponent/CustomAmountAlert";
import { PaymentAmountRestriction } from "../SharedComponent/PaymentAmountRestriction";
import PhoneIcon from '@material-ui/icons/Phone';

const LightToolTip = withStyles((theme) => ({
  arrow: {
    color: '#235A86'
  },
  tooltip: {
    backgroundColor: '#235A86',
    color: '#fffff',
    fontFamily: "Montserrat",
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    padding: "16px",
    fontSize: 14,
    maxWidth: 400,
    fontWeight: 500,
    borderRadius: 8
  },
}))(Tooltip);

export const Payment = (props) => {
 
  const classes = useStyles();
  const componentRef = useRef();
  const history = useHistory();
  const theme = useTheme();
  const dispatch = useDispatch();
  const addBankRef = useRef();

  const privateLabelUrl = Cookies.get("privateLabelUrl");
  const selectedAccount = props.userDetails.accountNumber;
  const mediaQuery = useMediaQuery(theme.breakpoints.down('sm'));
  const mytheme = useSelector(state => state.theme);
  const loanInfoData = useSelector(state => state?.loanInfoReducer);
  const { customerCareNumber } = mytheme;

  const {userDetails, purgedLoanInfo, purgedMsg} = props;
  const [dataLoading, setDataLoading] = useState(false);
  
  const [addPay, setAddPay] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [radioValue, setRadioValue] = useState('');
  const [open, setOpen] = useState(false);
  const [draftOTPError, setDraftOTPError] = useState('');
  const [draftOTPRes, setDraftOTPRes] = useState([]);
  const [otpApiData, setOtpApiData] = useState(null);
  const [otpApiErrorData, setOtpApiErrorData] = useState('');
  const [bankName, setBankName] = useState([]);
  const [totalPayment, setTotalPayment] = useState('');
  const [makePayLoading, setMakePayLoading] = useState(false);
  const [selectedAccountNo, setSelectedAccountNo] = useState('');
  const [selectedBank, setSelectedBank] = useState('');
  const [updatedProcessFee, setUpdatedProcessFee] = useState('');
  const [tncSummary, setTncSummary] = useState('');
  const [bankNameError, setBankNameError] = useState('');
  const [selectedBankError, setSelectedBankError] = useState('');
  const [newAddedAccount, setNewAddedAccount] = useState(null);
  const [additionalPayAmount, setAdditionalPayAmount] = useState({
    principalAmount: 0,
    escrowAmount: 0
  });
  const [saveAmountData, setSaveAmountData] = useState({
    processingFee: 0,
    principalAmount: 0,
    escrowAmount: 0,
    forbearanceApplicationFee: 0,
  });
  const [otpPaymentData, setOtpPaymentData] = useState({
    processingFee: 0,
    principalAmount: 0,
    escrowAmount: 0,
    bankAccount: ''
  });
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [disablePaymentButton, setPaymentBtnDisable]= useState(false);
  const [error, setError] = useState('');
  const [reviewPopupStatus, setReviewPopupStatus] = useState(false);
  const [paymentDate, setDate] = useState('');
  const [openOutstandingBalanceTooltip, setOpenOutstandingBalanceTooltip] = useState(false);
  const [openCustomBalanceTooltip, setOpenCustomBalanceTooltip] = useState(false);
  const [openPayingMoreTooltip, setOpenPayingMoreTooltip] = useState(false);
  const [openProcessingFeeTooltip, setOpenProcessingFeeTooltip] = useState(false);
  const [data, setData] = useState();
  const [showRestrictionPopup, setShowRestrictionPopup] = useState(false);
  const [accountRequiredPopup, setAccountRequired] = useState(false);
  const [bankDetailsDelete, setDeleteConfirmation] = useState(false);
  const [showCutOffPopup, setCutOffPopup] = useState(false);
  const [serviceTransferPopup, setServiceTransferPopup] = useState(false);
  const [customAlertPopup, setCustomAlertPopup] = useState(false);
  const [goToHomePage, setGoToHomePage] = useState(false)
  const [paymentAmtRestriction, setPaymentAmtRestriction] = useState(false);
  const [showCustom, setDisplayCustom] = useState(false);
 
  const handleOutstandingBalanceTooltipClose = () => {
    setOpenOutstandingBalanceTooltip(false);
  };

  const handleOutstandingBalanceTooltipOpen = () => {
    setOpenOutstandingBalanceTooltip(true);
  };

  const handleCustomBalanceTooltipClose = () => {
    setOpenCustomBalanceTooltip(false);
  };

  const handleCustomBalanceTooltipOpen = () => {
    setOpenCustomBalanceTooltip(true);
  };

  const handlePayingMoreTooltipClose = () => {
    setOpenPayingMoreTooltip(false);
  };

  const handlePayingMoreTooltipOpen = () => {
    setOpenPayingMoreTooltip(true);
  };

  const handleProcessingFeeTooltipClose = () => {
    setOpenProcessingFeeTooltip(false);
  };

  const handleProcessingFeeTooltipOpen = () => {
    setOpenProcessingFeeTooltip(true);
  };

  const toggleOpen = () => {
    setOpen(!open);
  }

  const changeAddRemovePay = () => {
    setAddPay(!addPay);
    setAdditionalPayAmount({
      principalAmount: 0,
      escrowAmount: 0
    })
    setOtpPaymentData({
      ...otpPaymentData,
      principalAmount: 0,
      escrowAmount: 0
    });
    setSaveAmountData({
      ...saveAmountData,
      principalAmount: 0,
      escrowAmount: 0,
    });
  }
  const ToggleAccountPopup = (saved) => {
    if (saved === 'Saved') {
    }
    setShowPopup(!showPopup);
  }

  const handleRadioChange = (event, val) => {
    if (event.target.value === 'onlyForbearance') {
      setOtpPaymentData({
        ...otpPaymentData,
        ['paymentType']: event.target.value,
        ['paymentTypeValue']: val,
        processingFee: 0,
        forbearanceApplicationFee: val,
        principalAmount: 0,
        escrowAmount: 0,
        graysDays: '',
        propertyState: '',
        investorCode: '',
        bankProfileID: 0,
      });
      setAdditionalPayAmount({
        principalAmount: 0,
        escrowAmount: 0
      })
    } else {
      setOtpPaymentData({
        ...otpPaymentData,
        ['paymentType']: event.target.value,
        ['paymentTypeValue']: val,
        processingFee: otpPaymentData.processingFee,  
        principalAmount: saveAmountData.principalAmount,
        escrowAmount: saveAmountData.escrowAmount,
        forbearanceApplicationFee: saveAmountData.forbearanceApplicationFee,
      });
    }
    setRadioValue(event.target.value);
  };

  const handleCustomAmount = (event) => {
    if (checkDigitWithDecimal(event.target.value)) {
      setOtpPaymentData({
        ...otpPaymentData,
        paymentTypeValue: event.target.value,
      })
    }
  }


  const handleAdditionalPayChange = (event, ke) => {
    if (checkDigitWithDecimal(event.target.value)) {
      setDraftOTPError('');
      setAdditionalPayAmount({
        ...additionalPayAmount,
        [ke]: event.target.value,
      });
      setOtpPaymentData({
        ...otpPaymentData, [ke]: event.target.value
      });
      setSaveAmountData({
        ...saveAmountData,
        [ke]: event.target.value
      })
    }
  }

  useEffect(() => {
    if (otpApiData && otpPaymentData) {
      setPaymentTotal();
    }
  }, [otpPaymentData, otpApiData])

  const getContentData = async () => {
    const res = await dispatch(getContent('PC016'));
    if (res && res.length !== 0) {
      setTncSummary(res[0].contentValue)
    }
  }

  const setPaymentTotal = () => {
    if (otpPaymentData.paymentType === 'onlyForbearance') {
      setTotalPayment(otpPaymentData.forbearanceApplicationFee)
    } else {
      setTotalPayment((otpPaymentData.paymentTypeValue ? Number(otpPaymentData.paymentTypeValue) : 0) + otpPaymentData.processingFee +
        Number(otpPaymentData.principalAmount) + Number(otpPaymentData.escrowAmount) +
        otpPaymentData.forbearanceApplicationFee)
    }
  }

  const updateProcessFee = (fee, date, processNote, delinquentDays, isDisplay) => {
    const processingNote = processNote?.replace("[PaymentAmount]", otpPaymentData.paymentTypeValue);
    setUpdatedProcessFee(fee);
    setOtpPaymentData({
      ...otpPaymentData,
      processingFee: fee,
      paymentDate: date,
      processingFeeNote: processingNote,

    })
    setOtpApiData({
      ...otpApiData,
      delinquentDays: delinquentDays,
      processingFeeIsDisplay: isDisplay
    })
  }

  useEffect(() => {
    getContentData();
  }, [])

  useEffect(() => {
    selctBankAcc();
  }, [bankName]);

  const selctBankAcc = () => {
    if (bankName && bankName.length) {
      const selectBankAccDetail = bankName.find(bankAccount => bankAccount.bankAccountNumber === newAddedAccount);
      if (selectBankAccDetail) {
        changeSelectedBank(selectBankAccDetail);
        setNewAddedAccount(null);
      } else {
        const selectBankAccPreff = bankName.find(bankAccount => bankAccount.isPreferredAcc === true);
        selectBankAccPreff ? changeSelectedBank(selectBankAccPreff) : changeSelectedBank(bankName[0])
      }
    }
  }

  const newAddedBankAccount = (newAddedBank) => {
    setNewAddedAccount(newAddedBank);
  }

  // useEffect(() => {
  //   if (selectedAccount) {
  //      getOTPDetails();
  //   }
  //   selctBankAcc();
  // }, [selectedAccount]);

  useEffect(() => {
       getOTPDetails();
  }, []);

  const getOTPDetails = async () => {
    setDataLoading(true);
    const response = await getOneTimeACHPaymentDetailsQuickPay(userDetails);
    if (response && response.lstResponseStatus && (response.lstResponseStatus[0].statusCode == 0)) {
      setOtpApiData(response);

      setOtpPaymentData({
        ...otpPaymentData,
        paymentType: response.isBKChapter13 ? 'isCustomAmount' : response.delinquentDays > 1 ? 'Outstanding' : 'Regular',
        paymentTypeValue: response.isBKChapter13 ? 0.00 : response.delinquentDays > 1 ? response.totalAmountDue : response.monthlyAmountDue,
        paymentDate: response.paymentDueDate,
        latePaymentDate: response.latePaymentDate,
        processingFee: response.processingFee.processingFee,
        forbearanceApplicationFee: response.forbearanceApplicationFee,
        graysDays: response.graceDays,
        propertyState: 'LA',
        investorCode: response.investorCode,
      });
      setSaveAmountData({
        ...saveAmountData,
        processingFee: response.processingFee.processingFee,
        forbearanceApplicationFee: response.forbearanceApplicationFee,
      })
      setOtpApiErrorData('');
      setDataLoading(false);
      // if (data == null) {
      //   getRecurringData()
      // } else {
      //   setOpenStatus(data.isRecurringAllowed)
      //   setlstRecurStatus(data?.lstRecurACH)
      // }
      if (!response.isBKChapter13) {
        getRecurringData()
      }
    } else if (response && response.lstResponseStatus && (response.lstResponseStatus[0].statusCode !== 0)) {
      setDataLoading(false);
      setOtpApiData(response);
      setOtpApiErrorData(response.lstResponseStatus[0].statusDesc);
    } else {
      setDataLoading(false);
      setOtpApiErrorData(renderDefaultMsg('400'));
    }
  }
   
  const changeSelectedBank = (data) => {
    setSelectedAccountNo(data.bankProfileID);
    setSelectedBank(data);
  }

  const validateBankDetails = () => {
    if (selectedBank === '' || selectedAccountNo === '') {
      return true;
    }
    return false;
  }
 
  const sendActivityData = async () => {
    const data = {
      "accountNumber": selectedAccount,
      "activityCode": "UAL212",
      "activityStatus": "Success",
      "action": 'DraftOneTimePayment',
      "controller": 'Payment',
      "apiName": "OTPayment/DraftOneTimePayment",
      "activityRemark": 'UI- QuickPay: Borrower Clicked on Make payment Button',
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": "",
    };

    await insertActivityLogQuickPay(data, userDetails);
  }

  const getPaymentType = () => {
     if (otpApiData.paymentType == 'Regular') {
      return "Regular Amount"
     } else if (otpApiData.paymentType == 'Outstanding') {
      return "Total Outstanding Amount"
     } else {
      return "Custom Amount"
     }
  }

  const draftOneTimePayment = async () => {
    setError('')
    setDate('')
    setDraftOTPError('');
    setMakePayLoading(true);
    if (validateBankDetails()) {
      // scrollToAddBankAccount();
      setMakePayLoading(false);
      setSelectedBankError('Please add a bank account.')
      setPaymentBtnDisable(false)
      const element = document.getElementById("addBankAccount");
      element?.scrollIntoView({ behavior: "smooth" });
    } else {
      setSelectedBankError('');
      setDataLoading(true)
    
      const paymentData = {
        "accountNumber": selectedAccount,
        "abaRoutingNumber": selectedBank.abaRoutingNumber,
        "bankCity": selectedBank.bankCity && selectedBank.bankCity.length ? selectedBank.bankCity : 'NA',
        "bankName": selectedBank.bankName && selectedBank.bankName.length ? decrypt(selectedBank.bankName) : 'NA',
        "bankState": selectedBank.bankState && selectedBank.bankState.length ? selectedBank.bankState : 'NA',
        "bankAccountNumber": encrypt(selectedBank.bankAccountNumber),
        "accountType": selectedBank.accountType,
        "borrowerType": "T",
        "borrowerName": selectedBank.borrowerName,
        "paymentDate": moment(otpPaymentData.paymentDate).format("L"),
        "paymentAmount": otpPaymentData.paymentTypeValue,
        "additionalPrincipal": otpPaymentData.principalAmount !== '' ? otpPaymentData.principalAmount : 0,
        "additionalEscrow": otpPaymentData.escrowAmount !== '' ? otpPaymentData.escrowAmount : 0,
        "confirmationNumber": 0,
        "achDraftStatus": "",
        "graysDays": otpPaymentData.graysDays,
        "propertyState": userDetails.propertyState,
        "investorCode": otpPaymentData.investorCode,
        "bankProfileID": selectedBank.bankProfileID,
        "draftFee": otpPaymentData.processingFee,
        "warningCode": otpApiData?.warningCode,
        "agencyFlag": userDetails.agencyFlag,
        "delinquentDays": otpApiData.delinquentDays,
        "loanStatus": otpApiData.loanStatus,
        "processingFeeNote": otpPaymentData.processingFeeNote,
        "IsForbearanceApplicationFeePayed": otpApiData.forbearanceApplicationFee === 0 ? false : true,
        "isCustomAmount": otpApiData.isCustomAmount,
        "firstName": userDetails.pBorrowerName,
        "emailId": userDetails.emailID,
        "paymentType": getPaymentType(),
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get('publicIp'),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName": "",
        "isBKChapter13": otpApiData.isBKChapter13
      }
  
      const response = await getDraftOneTimePaymentQuickPay(paymentData, userDetails);
      if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode === '0') {
        setMakePayLoading(false);
        setDraftOTPRes(response);
        setDraftOTPError('');
        setError('')
        toggleOpen();
        setPaymentBtnDisable(false)
        sendActivityData()
        setDataLoading(false)
        props.handleDraftPaymentResponse({code : response.confirmationNumber,
                    paymentDate : moment(otpPaymentData.paymentDate).format("L"),
                    selectedBank: selectedBank, totalPayment: numberWithCommas(totalPayment.toFixed(2)),
                    autoPay: (data?.lstRecurACH?.length > 0) ? true : false,
                    isBKChapter13: otpApiData.isBKChapter13})
      } else if (response && response.lstResponseStatus && response.lstResponseStatus[0].statusCode !== '0') {
        setMakePayLoading(false);
        setDataLoading(false)
        if (response.lstResponseStatus[0].statusDesc?.toUpperCase()?.includes("DUPLICATE DRAFT")) {
          setError(response.lstResponseStatus[0].statusDesc)
          setDate(otpPaymentData.paymentDate)
          setDraftOTPError('')
        } else {
          setDraftOTPError(response.lstResponseStatus[0].statusDesc);
          setError('')
        }
        setPaymentBtnDisable(false)
      } else {
        setDataLoading(false)
        setMakePayLoading(false);
        setDraftOTPError(renderDefaultMsg('400'));
        setError('')
        setPaymentBtnDisable(false)
      }
    }
  }
 
  const removeBankAccount = () => {
    setSelectedAccountNo('')
    setSelectedBank('')
    setBankName([])
    setDeleteConfirmation(false)
  }

  const addedNewAccount = (newAcc) => {
    setSelectedBankError('');
    bankName.push(newAcc);
    changeSelectedBank(newAcc);
  }

  const handleCloseAlert = () => {
    setAlertOpen(false)
    setReviewPopupStatus(true)
  }
  
  const callDebounce = () => {
    if ((totalPayment == 0))  {
      setPaymentAmtRestriction(true)
    } else {
      setPaymentAmtRestriction(false)
      if (otpApiData.isPast9PM && (moment(otpApiData?.estDateTime).format('YYYY-MM-DD') == moment(otpPaymentData.paymentDate).format('YYYY-MM-DD'))) {
        setCutOffPopup(true)
      } else {
       if ((otpPaymentData.paymentType == 'Regular') && ((moment(otpPaymentData.paymentDate).format('YYYY-MM-DD') > moment(otpApiData.maxCalenderDate60).format('YYYY-MM-DD')))) {
         if (otpApiData.isServiceRelease60) {
             setServiceTransferPopup(true) }
           else {
             setShowRestrictionPopup(true)
         }
       } else if((otpPaymentData.paymentType == 'isCustomAmount') && ((moment(otpPaymentData.paymentDate).format('YYYY-MM-DD') > moment(otpApiData.calenderDateCust).format('YYYY-MM-DD'))) && !otpApiData?.isBKChapter13) {
         if (otpApiData.isServiceRelease60) {
             setServiceTransferPopup(true) }
           else {
             setDisplayCustom(true)
             setShowRestrictionPopup(true)
         }
       } else if((otpPaymentData.paymentType !== 'Regular') && ((moment(otpPaymentData.paymentDate).format('YYYY-MM-DD') > moment(otpApiData.maxCalenderDate90).format('YYYY-MM-DD')))) {
         if (otpApiData.isServiceRelease90) {
           setServiceTransferPopup(true) }
           else {
             setShowRestrictionPopup(true)
         }
       } else {
         debounce(handleMakePayment(), 500);    
       } 
     } 
    }   
  }
  
  const handleCloseReviewPopup = () => {
    setReviewPopupStatus(false)
  }

  const handleContinueReviewPopup = () => {
    setReviewPopupStatus(false)
    draftOneTimePayment()
  }

  const handleMakePayment = () => {
    if (validateBankDetails()) {
      setSelectedBankError('Please add a bank account.') 
      const element = document.getElementById("addBankAccount");
      element?.scrollIntoView({ behavior: "smooth" });
    } else {
        setReviewPopupStatus(true)
    }   
  }

  const getRecurringData = async () => {
    const res = await getRecurringACHInfoQuickPay(userDetails);
    if (res && res.lstResponseStatus[0].statusCode == 0) {
      // setOpenStatus(res.isRecurringAllowed);
      // setlstRecurStatus(res?.lstRecurACH);
      setData(res)
      setGoToHomePage(true)

    } else {
      setGoToHomePage(true)
      setOtpApiErrorData(renderDefaultMsg('400'));
    }
  }
  
  const routeToRequestPayOff = () => {
    history.push('/PayoffRequest');
  }

  const handleClose = () => {
    setAlertOpen(false);
  }

  const handleFinancialHardshipAlertClose = () => {
    setOpen(false)
  }

  let allCoBorrwerNameData = '';
  if (bankName && bankName.length) {
    allCoBorrwerNameData = bankName.map((bank, index) => {
      return (
        <MenuItem value={bank.bankProfileID} key={`${bank.bankProfileID}_${bank.nickName}`} onClick={() => changeSelectedBank(bank)}>
          {`${bank.nickName} ${maskAccountNo(decrypt(bank.bankAccountNumber))}`}</MenuItem>
      )
    })
  }

  const handleOkBtn = () => {
    setShowRestrictionPopup(false)
  }

  const getContactNumber = () => {
    if (otpApiData.DelinquentDays < 30)
      {
          return userDetails?.agencyFlag == "N" ? userDetails['bsI0_29NonAgency'] : userDetails['bsI0_29Agency'];
      }
      else if (otpApiData.DelinquentDays < 60)
      {
        return  userDetails?.agencyFlag == "N" ?  userDetails['bsI30_59NonAgency'] : userDetails['bsI30_59Agency'];
      }
      else if (otpApiData.DelinquentDays > 80 && otpApiData.DelinquentDays < 91)
      {
        return userDetails?.agencyFlag == "N" ? userDetails['bsI30_59NonAgency'] : userDetails['bsI30_59Agency'];
      }
      else
      {
        return userDetails?.agencyFlag == "N" ? userDetails['bsI60_NonAgency'] : userDetails['bsI60_Agency'];
      }
  }

  const scrollToAddBankAccount = () => {
    setTimeout(() => {
      const element = document.getElementById("addBankAccount");
      element.scrollIntoView({behavior: "smooth"});
    }, 1000);
  }

  const handleCutOffBtn = () => {
    setCutOffPopup(true)
  }

  if (dataLoading) {
    return (
      <Box className={classes.loader}>
        <CircularProgress />
      </Box>
    )
  }

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  
  if (dataLoading === false) {
    return (
      <Box className={classes.root} ref={componentRef} >
        <div>
        
      {(otpApiErrorData !== "") && <h4 className={classes.apiError}>{otpApiErrorData}</h4>}

      {otpApiData?.isLMTPPFlag && ((otpApiData?.spoCname) || (otpApiData?.spoCphone) || (otpApiData?.spoCemail)) && <Box className={classes.spocContainer}>
          <Grid container direction="row" alignItems="center">
            <Grid item md={12} xs={12} lg={12}>
              <Typography className={classes.informationTexts}>
              You are in an active loss mitigation trial plan, you will need to make the payment over the phone with your Single Point of Contact or via mail.</Typography>
              <Typography className={classes.spocInfo}>Single Point of Contact (SPOC)</Typography>
              {otpApiData?.spoCname && <Typography className={classes.informationTexts}>Name: <span className={classes.servicerText}> {decrypt(otpApiData?.spoCname)}</span></Typography>}
              {otpApiData?.spoCphone && <Typography className={classes.callUs}>Phone:
                <a href={"tel:" + otpApiData?.spoCphone} style={{textDecoration: 'none', cursor: 'pointer'}}> <span className={`${classes.contactTime} ${classes.noUnderLine}`} >{decrypt(otpApiData?.spoCphone)}</span></a></Typography>}
                {otpApiData?.spoCemail && <Typography className={classes.informationTexts}>Email: <span className={classes.servicerText}> {decrypt(otpApiData?.spoCemail)}</span></Typography>}
            </Grid>
          </Grid>
        </Box> }

        {otpApiData?.isLMTPPFlag && ((!otpApiData?.spoCname) && (!otpApiData?.spoCphone) && (!otpApiData?.spoCemail)) && <Box className={classes.spocContainer}>
          <Grid container direction="row" alignItems="center">
            <Grid item md={12} xs={12} lg={12}>
              <Typography className={classes.informationTexts}>
              You are in an active loss mitigation trial plan, you will need to make the payment over the phone with your Single Point of Contact or via mail. <a href="./HelpLanding?contactus" target="_blank" className={classes.contact}>Contact us</a></Typography>
            </Grid>
          </Grid>
        </Box>}
        
       { purgedLoanInfo?.isLoanPurged && 
        <Box className={classes.liquidationBox}>
          <Box className={classes.transferBox}>
            <Grid container direction="row" alignItems="center" style={{ paddingLeft: '5px' }}>
              <Grid item md={12} xs={12} lg={12}>
                <Box display='flex' alignItems="center">
                  <Typography className={classes.informationText}>{purgedMsg}</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box> 
       </Box> 
      }

      { (getChargedOffStatus(purgedLoanInfo) && !purgedLoanInfo?.isLoanPurged) &&
        <>
        <Box className={classes.liquidationBox}>
          <Box className={classes.transferBox}>
            <Grid container direction="row" alignItems="center" style={{ paddingLeft: '5px' }}>
              <Grid item md={12} xs={12} lg={12}>
                <Box display='flex' alignItems="center">
                  <img src={checkmark} className={classes.checkmarkIcon}/>      
                  <Typography className={classes.informationText}>This {getMortgageLabel()?.toLowerCase()} {getLoanLabel()?.toLowerCase()} has been charged off.</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box> 
          <Box style={{padding: '12px'}}>
        { (props?.liquidationType == 'chargedOff') &&
          <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You may obtain more information within your charge off billing statement. Please note that the balance on the {getAccountLabel()?.toLowerCase()} is not being canceled or forgiven; and the {getLoanLabel()?.toLowerCase()} may be purchased, assigned, or transferred.</Typography></Box>
        }
          <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You will now only have view rights, which will allow you to access information about your {getLoanLabel()?.toLowerCase()} balance, payment history, and {getAccountLabel()?.toLowerCase()} details.</Typography></Box>
          <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You can view/download the available documents in  <a className={classes.link} onClick={() => setAccountRequired(true)}>document center</a> as usual before.</Typography></Box>
          { ((privateLabelUrl.toLowerCase() !== "aafmaa") && !isHEI()) &&
          <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You can also request any missing {getMortgageLabel()?.toLowerCase()} document from <a className={classes.link} onClick={() => setAccountRequired(true)}>document request</a> feature.</Typography></Box> }
          </Box>
       </Box> 
      </>
      }

      { (getFCLCompletedStatus(purgedLoanInfo) && !purgedLoanInfo?.isLoanPurged) &&
      <>
      <Box className={classes.liquidationBox}>
        <Box className={classes.transferBox}>
          <Grid container direction="row" alignItems="center" style={{ paddingLeft: '5px' }}>
            <Grid item md={12} xs={12} lg={12}>
              <Box display='flex' alignItems="center">
                <img src={checkmark} className={classes.checkmarkIcon}/>      
                <Typography className={classes.informationText}>A foreclosure sale date has been held with respect to this property.</Typography>
              </Box>
            </Grid>
      
          </Grid>
        </Box> 
        <Box style={{padding: '12px'}}>
         <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You will now only have view rights, which will allow you to access information about your {getLoanLabel()?.toLowerCase()} balance, payment history, and {getAccountLabel()?.toLowerCase()} details.</Typography></Box>
         <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You can view/download the available documents in  <a className={classes.link} onClick={() => setAccountRequired(true)}>document center</a> as usual before.</Typography></Box>
         { ((privateLabelUrl.toLowerCase() !== "aafmaa") && !isHEI()) &&
         <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You can also request any missing {getMortgageLabel()?.toLowerCase()} document from <a className={classes.link} onClick={() => setAccountRequired(true)}>document request</a> feature.</Typography></Box> }
        </Box>
       </Box> 
      </> 
      }
    
     { (getPayOffStatus(purgedLoanInfo) && !purgedLoanInfo?.isLoanPurged) &&
     <>
      <Box className={classes.liquidationBox}>
        <Box className={classes.transferBox}>
          <Grid container direction="row" alignItems="center" style={{ paddingLeft: '5px' }}>
            <Grid item md={12} xs={12} lg={12}>
              <Box display='flex' alignItems="center">
                <img src={checkmark} className={classes.checkmarkIcon}/>              
                <Typography className={classes.informationText}>Your {getLoanLabel()?.toLowerCase()} has been paid in full.</Typography>
              </Box>
            </Grid>
          </Grid>
        </Box> 
       <Box style={{padding: '12px'}}>
      
         <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You will now only have view rights, which will allow you to access information about your {getLoanLabel()?.toLowerCase()} balance, payment history, and {getAccountLabel()?.toLowerCase()} details.</Typography></Box>
         <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You can view/download the available documents in  <a className={classes.link} onClick={() => setAccountRequired(true)}>document center</a> as usual before.</Typography></Box>
         { ((privateLabelUrl.toLowerCase() !== "aafmaa") && !isHEI()) &&
         <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You can also request any missing {getMortgageLabel()?.toLowerCase()} document from <a className={classes.link} onClick={() => setAccountRequired(true)}>document request</a> feature.</Typography></Box> }
        </Box>
       </Box> 
      </>
      }

        { (getServiceTransferStatus(purgedLoanInfo) && !purgedLoanInfo?.isLoanPurged) &&
          <>
        <Box className={classes.liquidationBox}>
          <Box className={classes.transferBox}>
            <Grid container direction="row" alignItems="center" style={{ paddingLeft: "10px" }}>
              <Grid item md={11} xs={11} lg={11}>
                <Box display='flex' alignItems="center" >
                  <img src={checkmark} className={classes.checkmarkIcon}/>   
                  <Typography className={classes.informationText}>Your {getLoanLabel()?.toLowerCase()} has been transferred to new servicer.</Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box style={{padding: '12px'}}>
      
          <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You will now only have view rights, which will allow you to access information about your {getLoanLabel()?.toLowerCase()} balance, payment history, and {getAccountLabel()?.toLowerCase()} details.</Typography></Box>
          <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You can view/download the available documents in  <a className={classes.link} onClick={() => setAccountRequired(true)}>document center</a> as usual before.</Typography></Box>
          { ((privateLabelUrl.toLowerCase() !== "aafmaa") && !isHEI()) &&
          <Box style={{display: 'flex'}}><img src={tick} alt="check icon" className={classes.tick}/><Typography className={classes.liquidationText}>You can also request any missing {getMortgageLabel()?.toLowerCase()} document from <a className={classes.link} onClick={() => setAccountRequired(true)}>document request</a> feature.</Typography></Box> }
         </Box>
        </Box> 
       </>
      }

        {  (!purgedLoanInfo?.liquidationStatus && !purgedLoanInfo?.isLoanPurged) &&  
        <>
        {  (otpApiData && !otpApiData.isACHSuspended && !otpApiData.isPaymentAllowed && !otpApiData.isPaymentNotAllowedInvCode) ? <><Box className={classes.pastDueDays}>
          <Typography className={classes.title}>Payment Summary</Typography>
          {(otpApiData.loanStatus !== 'BKY') && <Button className={classes.alertBtn}>{otpApiData?.delinquentDays} days past due</Button> }
         
          <Box className={classes.paddingFix}>
            <InfoIcon style={{ fill: '#B00020' }} />
            <Typography className={classes.alertTitle}>Due to the status of your loan, payment details are currently disabled. Please <a href="./HelpLanding?contactus" target="_blank" className={classes.contactUs}>contact us</a> directly to discuss your payment options and Outstanding Payment Amount.</Typography>
          </Box> 
        </Box> 
       {(otpApiData.loanStatus !== 'BKY') && 
        <Box className={classes.hardship}>
            <Typography className={classes.financialText}>If you're experiencing financial hardship, we’re here to help you explore available options and create a plan to keep your home. <a className={classes.link} onClick={() => setAccountRequired(true)}>Click here</a> to seek financial assistance and learn more.</Typography>
        </Box> }
        </>
        :
        
        otpApiData && !otpApiData.isPaymentNotAllowedInvCode && !otpApiData.isACHSuspended && !purgedLoanInfo?.isLoanPurged && (!otpApiData.isBKChapter13 && !otpApiData?.isLMTPPFlag) ?

          <Box className={(otpApiData.isPaymentAllowed && otpApiData.delinquentDays < 2) ? classes.greenBanner : (otpApiData.isPaymentAllowed) ? classes.banner : classes.redBanner}>
            <Box className={otpApiData.delinquentDays < 2 ? clsx(classes.countBox, classes.whiteBorder) : otpApiData.isPaymentAllowed ? classes.countBox : clsx(classes.countBox, classes.whiteBorder)}><Typography className={otpApiData.delinquentDays < 2 ? clsx(classes.countText, classes.whiteColor) : otpApiData.isPaymentAllowed ? classes.countText : clsx(classes.countText, classes.whiteColor)}>{otpApiData.delinquentDays}</Typography></Box>
            <p className={otpApiData.delinquentDays < 2 ? clsx(classes.bannerText, classes.whiteColor) : otpApiData.isPaymentAllowed ? classes.bannerText : clsx(classes.bannerText, classes.whiteColor)}>{otpApiData.delinquentMessage?.replace("[Phone]", getContactNumber())}</p>
            {!otpApiData.isPaymentAllowed && <IconButton onClick={() => setOpen(true)}><ErrorIcon style={{ fill: '#fff' }} /></IconButton>}
          </Box>
          :
          null
        }

        {otpApiData && otpApiData.isPaymentNotAllowedInvCode && !otpApiData.isACHSuspended && !purgedLoanInfo?.isLoanPurged ?
          <Box className={classes.redBanner}>
            <Box><p className={classes.whiteColor}>{ACCOUNT_TOOLTIP}</p>
            </Box>
          </Box>
          :
          null
        }
        {otpApiData && otpApiData.isPaymentNotAllowedInvCode && otpApiData.isACHSuspended && !purgedLoanInfo?.isLoanPurged ?
          <Box className={classes.redBanner}>
            <Box><p className={classes.whiteColor}>{ACCOUNT_TOOLTIP}</p>
            </Box>
          </Box>
          :
          null
        }
        {otpApiData && otpApiData.isACHSuspended && otpApiData.isPaymentAllowed && !purgedLoanInfo?.isLoanPurged && (!otpApiData.isBKChapter13 && !otpApiData?.isLMTPPFlag) ?
          <Box className={classes.redBanner}>
            <Box><p className={classes.whiteColor}>{achSuspensionMessage(customerCareNumber)}</p>
            </Box>
          </Box>
          :
          null
        }
        {otpApiData && otpApiData.isACHSuspended && !otpApiData.isPaymentAllowed && !purgedLoanInfo?.isLoanPurged && (!otpApiData.isBKChapter13 && !otpApiData?.isLMTPPFlag) ?
          <Box className={classes.redBanner}>
            <Box className={clsx(classes.countBox, classes.whiteBorder)}><Typography className={clsx(classes.countText, classes.whiteColor)}>{otpApiData.delinquentDays}</Typography></Box>
            <p className={clsx(classes.bannerText, classes.whiteColor)}>{otpApiData.delinquentMessage?.replace("[Phone]", getContactNumber())}</p>
            {!otpApiData.isPaymentAllowed && <IconButton onClick={() => setOpen(true)}><ErrorIcon style={{ fill: '#fff' }} /></IconButton>}
          </Box>
          :
          null
        }
        </> }
       
        { otpApiData && (numberWithCommas(otpApiData?.totalAmountDue.toFixed(2)) == 0.00) && otpApiData?.isPaymentAllowed && !purgedLoanInfo?.liquidationStatus && !purgedLoanInfo?.isLoanPurged && !otpApiData?.isBKChapter13 && !otpApiData?.isLMTPPFlag && <Box className={classes.zeroOutstanding}>
          <img src={clap} className={classes.checkmark}/>              
          <Typography className={classes.clearOutstanding}>Congratulations! Your account is clear of any Outstanding Payment Amount.</Typography>
        </Box> }

        {data && (data?.lstRecurACH?.length > 0) && !purgedLoanInfo?.isLoanPurged && !otpApiData?.isLMTPPFlag && !getChargedOffStatus(purgedLoanInfo) &&
        !getPayOffStatus(purgedLoanInfo) && !getServiceTransferStatus(purgedLoanInfo) && !getFCLCompletedStatus(purgedLoanInfo) && otpApiData.isPaymentAllowed && <><Box className={classes.autoPay}>
          <Grid container>
            <Grid item sm={12} md={10} style={{display: 'flex'}}>         
              <img src={checkmark} className={classes.checkmark}/>              
              <Typography className={classes.autoPayDate}>Your autopay <b>${data?.lstRecurACH[0].totalAmountDrafted}</b> is scheduled on <b>{moment(data?.lstRecurACH[0].nextDraftDate).format("ll")}</b>.</Typography>
            </Grid>
            <Grid item sm={12} md={2}>    
              <Typography className={classes.manageAutoPay} onClick={() => setAccountRequired(true)}>Manage Autopay</Typography>
            </Grid>
          </Grid> 
        </Box>
        <Box className={classes.paymentNote}>
           <b>Note: </b> This payment will not impact your autopay. That payment will continue to process unless it is cancelled or changed 3 business days in advance of the scheduled draft.
        </Box>
        </> }

       {(!purgedLoanInfo?.liquidationStatus && !purgedLoanInfo?.isLoanPurged && otpApiData && otpApiData?.isPaymentAllowed && !otpApiData?.isLMTPPFlag) ? <>

       { !otpApiData.isBKChapter13 && <>
        <Grid container>
          <Grid item sm={12} md={8}>               
              <Typography className={classes.paymentType}>Select Payment Type</Typography>
          </Grid>

          <Grid item sm={12} md={4}>               
              {!otpApiData?.isBKChapter13 && <Box className={classes.confirmationStatusContainer}><span style={{color: '#1A4664'}}>Due Date:</span> {moment(otpApiData?.paymentDueDate).format("ll")} </Box>}
          </Grid>
        </Grid>
        <Box className={classes.paymentLine} id="addBankAccount"></Box> </>}

          <Grid container alignItems="center" className={(otpApiData.isBKChapter13 || !otpApiData?.isRegularPayment) ? classes.oneTimePaymentBkContainer : classes.oneTimePaymentContainer}>
            <Box className={`${classes.paymentDetailsBox} ${classes.paymentTypeBox}`} style={{ background: '#fff' }}>
              <Box className={classes.paymentDetails}>
              
                <Box className={`${classes.paymentOptionsBox} ${classes.block}`}>
                  <Box width='100%'>
                  { !otpApiData?.isBKChapter13 && <> 
                   { (numberWithCommas(otpApiData?.monthlyAmountDue.toFixed(2)) >= numberWithCommas(otpApiData?.totalAmountDue.toFixed(2))) ? 
                    <div className={classes.radioBtn}>
                      <Box style={{ width: '70%' }}>
                        <RadioGroup row className={classes.alignCenter} aria-label="account_type" name="account_type" value={radioValue}
                          onChange={(e) => handleRadioChange(e, otpApiData.monthlyAmountDue)}>
                          <FormControlLabel value="Regular"  className={!otpApiData?.isRegularPayment ? classes.radioLabelDisable : classes.radioLabelEnable}  checked={((otpPaymentData.paymentType === 'Regular') && (numberWithCommas(otpApiData?.monthlyAmountDue.toFixed(2)) >= numberWithCommas(otpApiData?.totalAmountDue.toFixed(2)))) ? true : false}
                            control={<Radio disabled={!otpApiData?.isRegularPayment ? true : false}/>}
                            label="Regular Monthly Payment" />
                         
                          <LightToolTip
                            arrow placement="bottom" title={"Regular monthly payment of principal, interest, and escrow"} >
                            <InfoIcon className={classes.paymentRadioInfo} />
                          </LightToolTip> 
                          
                        </RadioGroup>
                        <Typography className={otpApiData?.isRegularPayment ? classes.regularPaymentDescEnable : classes.regularPaymentDescDisable} arrow placement="bottom">
                          Regular monthly payment of principal, interest, and escrow
                      </Typography>
                      </Box>
                      <Typography className={`${otpApiData?.isRegularPayment ? classes.bodyTitle : classes.disableBodyTitle} ${classes.alignSelftEnd}`} style={{ marginTop: '10px !important' }}>
                        ${numberWithCommas(otpApiData?.monthlyAmountDue.toFixed(2))}
                      </Typography>
                    </div> : 
                    <div className={classes.radioBtn}>
                    <Box style={{ width: '70%' }}>
                      <RadioGroup row className={classes.alignCenter} aria-label="account_type" name="account_type" value={radioValue}
                        onChange={(e) => handleRadioChange(e, otpApiData?.totalAmountDue)}>
                        <FormControlLabel className={(otpApiData?.totalAmountDue.toFixed(2) == 0.00) ? classes.radioLabelDisable : classes.radioLabelEnable} value="Outstanding" checked={((otpPaymentData.paymentType == 'Outstanding') && (numberWithCommas(otpApiData?.monthlyAmountDue.toFixed(2)) < numberWithCommas(otpApiData?.totalAmountDue.toFixed(2)))) ? true : false}
                          control={<Radio disabled={otpApiData?.totalAmountDue.toFixed(2) == 0.00 ? true : false}/>}
                          label="Total Outstanding Balance" />
                       
                        <LightToolTip
                          arrow placement="bottom" title={"Total outstanding balance including past dues / fees, etc."} >
                          <InfoIcon className={classes.paymentRadioInfo} />
                        </LightToolTip> 
                       
                      </RadioGroup>
                      <Typography className={(otpApiData?.totalAmountDue.toFixed(2) == 0.00) ? classes.regularPaymentDescDisable : classes.regularPaymentDescEnable}>
                        Total outstanding balance including past dues / fees, etc.
                    </Typography>
                    </Box>
                    <Typography className={`${otpApiData?.totalAmountDue.toFixed(2) == 0.00 ? classes.disableBodyTitle : classes.bodyTitle} ${classes.alignSelftEnd}`} style={{ marginTop: '10px !important' }}>
                      ${numberWithCommas(otpApiData?.totalAmountDue.toFixed(2))}
                    </Typography>
                  </div>
                    }
                    </>}

                    {(otpApiData?.isRegularPayment || otpApiData?.isBKChapter13) && (otpApiData.delinquentDays < 45) &&
                    <div className={classes.radioBtn}>
                      <Box>
                        <RadioGroup row className={classes.alignCenter} aria-label="account_type" name="account_type" value={radioValue}
                          onChange={(e) => handleRadioChange(e, otpApiData.monthlyAmountDue)}>
                          <FormControlLabel value="isCustomAmount" checked={otpPaymentData.paymentType == 'isCustomAmount' ? true : false}
                            control={<Radio />}
                            label="Custom Payment Amount" />
                        </RadioGroup>
                        <Typography className={classes.regularPaymentDescEnable} arrow placement="bottom">
                          Enter a custom amount greater than $0.00 and up to $50,000.00.
                        </Typography>
                       
                      {(otpPaymentData.paymentType == 'isCustomAmount') && <>
                        <Box className={classes.alignTextBox}>
                          <TextField
                            type="text"
                            value={otpPaymentData.paymentType == 'Outstanding' ? otpApiData.monthlyAmountDue : otpPaymentData.paymentTypeValue}
                            size='medium'
                            variant='outlined'
                            onChange={handleCustomAmount}
                            onBlur={() => setCustomAlertPopup(true)}
                            className={classes.customTextInput}
                            InputProps={{
                              classes: { root: classes.textField },
                              startAdornment: (
                                <InputAdornment position="start">
                                  <AttachMoneyIcon />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Box>
                        <Typography className={`${classes.bodySmallFont} ${classes.radioDes}`} arrow placement="bottom">
                           {otpApiData.isBKChapter13 ? 
                             <Typography style={{marginBottom: '8px'}}><span className={classes.note}>Note:</span> <span className={classes.customPaymentText}>The information provided online is to be used for informational purposes only.  It should in no way be considered an attempt to collect a debt in contravention of the automatic stay in bankruptcy.</span></Typography> :
                             <>
                              <Typography style={{marginBottom: '8px'}}><span className={classes.note}>Note:</span> <span className={classes.customPaymentText}> Funds received may not be applied towards the Outstanding Payment Amount to advance the due date until atleast full monthly payment has been received.</span>
                              </Typography>
                              <span className={classes.transactionHistory}>To view your transaction history, please <span className={classes.historyLink} onClick={() => setAccountRequired(true)}>Login</span> to the MLW portal.</span>
                              </> }
                        </Typography>
                      </>}  
                        
                      </Box>
                    </div>}
                  
                  { !otpApiData?.isBKChapter13 && <> 
                   {(numberWithCommas(otpApiData?.monthlyAmountDue.toFixed(2)) >= numberWithCommas(otpApiData?.totalAmountDue.toFixed(2))) ? 
                    <div className={classes.radioBtn}>
                      <Box style={{ width: '70%' }}>
                        <RadioGroup row className={classes.alignCenter} aria-label="account_type" name="account_type" value={radioValue}
                          onChange={(e) => handleRadioChange(e, otpApiData?.totalAmountDue)}>
                          <FormControlLabel className={otpApiData?.totalAmountDue.toFixed(2) == 0.00 ? classes.radioLabelDisable : classes.radioLabelEnable} value="Outstanding" checked={otpPaymentData.paymentType === 'Outstanding' ? true : false}
                            control={<Radio disabled={otpApiData?.totalAmountDue.toFixed(2) == 0.00 ? true : false}/>}
                            label="Total Outstanding Balance" />
                         
                          <LightToolTip
                            arrow placement="bottom" title={"Total outstanding balance including past dues / fees, etc."} >
                            <InfoIcon className={classes.paymentRadioInfo} />
                          </LightToolTip> 
                         
                        </RadioGroup>
                        <Typography className={(otpApiData?.totalAmountDue.toFixed(2) == 0.00) ? classes.regularPaymentDescDisable : classes.regularPaymentDescEnable}>
                          Total outstanding balance including past dues / fees, etc.
                      </Typography>
                      </Box>
                      <Typography className={`${otpApiData?.totalAmountDue.toFixed(2) == 0.00 ? classes.disableBodyTitle : classes.bodyTitle} ${classes.alignSelftEnd}`} style={{ marginTop: '10px !important' }}>
                        ${numberWithCommas(otpApiData?.totalAmountDue.toFixed(2))}
                      </Typography>
                    </div> :
                   
                    <div className={classes.radioBtn}>
                    <Box style={{ width: '70%' }}>
                      <RadioGroup row className={classes.alignCenter} aria-label="account_type" name="account_type" value={radioValue}
                        onChange={(e) => handleRadioChange(e, otpApiData.monthlyAmountDue)}>
                        <FormControlLabel value="Regular"  className={!otpApiData?.isRegularPayment ? classes.radioLabelDisable : classes.radioLabelEnable}  checked={((otpPaymentData.paymentType == 'Regular') && otpApiData?.isRegularPayment) ? true : false}
                          control={<Radio disabled={!otpApiData?.isRegularPayment ? true : false}/>}
                          label="Regular Monthly Payment" />
                      
                        <LightToolTip
                          arrow placement="bottom" title={"Regular monthly payment of principal, interest, and escrow"} >
                          <InfoIcon className={classes.paymentRadioInfo} />
                        </LightToolTip> 
                        
                      </RadioGroup>
                      <Typography className={otpApiData?.isRegularPayment ? classes.regularPaymentDescEnable : classes.regularPaymentDescDisable} arrow placement="bottom">
                        Regular monthly payment of principal, interest, and escrow
                    </Typography>
                    </Box>
                    <Typography className={`${otpApiData?.isRegularPayment ? classes.bodyTitle : classes.disableBodyTitle} ${classes.alignSelftEnd}`} style={{ marginTop: '10px !important' }}>
                      ${numberWithCommas(otpApiData?.monthlyAmountDue.toFixed(2))}
                    </Typography>
                    </div> }
                    </> }


                    {/* {otpApiData && otpApiData.isCustomAmount && <div className={classes.radioBtn}>
                      <Box style={{ width: '70%' }}>
                        <RadioGroup row className={classes.alignCenter} aria-label="account_type" name="account_type" value={radioValue}
                          onChange={(e) => handleRadioChange(e, otpApiData.monthlyAmountDue)}>
                          <FormControlLabel value="isCustomAmount" checked={otpPaymentData.paymentType === 'isCustomAmount' ? true : false}
                            control={<Radio />}
                            label="Custom Amount" />
                          
                          {!mediaQuery && <LightToolTip
                            arrow placement="bottom" title={"When there are no fees due, enter any custom amount greater than $0.00. To only pay fees due, enter $0.00"} >
                            <InfoIcon className={classes.paymentRadioInfo} />
                          </LightToolTip> }
                          {mediaQuery && 
                          <ClickAwayListener onClickAway={handleCustomBalanceTooltipClose}>
                            <LightToolTip
                                arrow placement="bottom" title={"When there are no fees due, enter any custom amount greater than $0.00. To only pay fees due, enter $0.00"}
                                open={ openCustomBalanceTooltip }
                              >
                                <InfoIcon className={classes.paymentRadioInfo} onClick={handleCustomBalanceTooltipOpen}/>
                              </LightToolTip>
                          </ClickAwayListener>}
                        </RadioGroup>
                        <Typography className={`${classes.bodySmallFont} ${classes.radioDes}`}>
                          When there are no fees due, enter any custom amount greater than $0.00. To only pay fees due, enter $0.00
                      </Typography>
                      </Box>
                      <Box className={classes.alignTextBox}>
                        <TextField
                          type="text"
                          disabled={otpPaymentData.paymentType === 'isCustomAmount' ? false : true}
                          value={otpPaymentData.paymentType === 'Outstanding' ? otpApiData.monthlyAmountDue : otpPaymentData.paymentTypeValue}
                          size='small'
                          variant='outlined'
                          onChange={handleCustomAmount}
                          className={classes.customTextInput}
                          InputProps={{
                            classes: { root: classes.textField },
                            startAdornment: (
                              <InputAdornment position="start">
                                <AttachMoneyIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                    </div>} */}

                  </Box>
                </Box>

               {!otpApiData.isBKChapter13 && <Typography className={classes.additionalPrincipal}>To pay towards additional principal / escrow, click here to <span className={classes.historyLink} onClick={() => setAccountRequired(true)}>sign in.</span></Typography>}
              </Box>

              {/* <Box className={`${classes.additionPayment}`}>
                <Box className={`${classes.paymentDetails} ${classes.pt0}`}>
                  <Box className={classes.flexBox}>
                    <Typography className={classes.additionalPayment}>
                      Additional Payment
                </Typography>
                    <Typography className={classes.payingMoreLink}>
                      Benefits of Paying More
                   
                      {!mediaQuery && <LightToolTip
                            arrow placement="bottom" title={BENEFIT_OF_PAYING_MORE} >
                            <InfoIcon className={classes.paymentRadioInfo} style={{marginLeft: '5px'}}/>
                          </LightToolTip> }
                      {mediaQuery && 
                      <ClickAwayListener onClickAway={handlePayingMoreTooltipClose}>
                        <LightToolTip
                            arrow placement="bottom" title={BENEFIT_OF_PAYING_MORE}
                            open={ openPayingMoreTooltip }
                          >
                            <InfoIcon className={classes.paymentRadioInfo} style={{marginLeft: '5px'}} onClick={handlePayingMoreTooltipOpen}/>
                          </LightToolTip>
                      </ClickAwayListener>}
                    </Typography>
                  </Box>
                   <Box className={classes.additionalDetails}>
                   
                    <>
                    <Box className={classes.flexBoxAdditionalPayment}>
                      <Box className={classes.inputContainer} style={{ position: 'relative' }}>
                        <TextField
                          color='primary'
                          id="outlined-loanNumber"
                          label="Additional Principal Amount"
                          variant="outlined"
                          type="text"
                          value={`${additionalPayAmount.principalAmount}`}
                          onChange={(event) => handleAdditionalPayChange(event, 'principalAmount')}
                          fullWidth
                          disabled={(otpApiData.warningCode == '3') ? true :  false}
                          className={`${(otpApiData.warningCode == '3') ? classes.disabledAdditionalPrincipal : classes.inputStyle} ${classes.pl20}`}
                          classes={{
                            root: classes.additionalPayTextField
                          }}
                          InputProps={{
                            classes: { root: classes.textField },
                            startAdornment: (
                              <InputAdornment position="start">
                                <AttachMoneyIcon />
                              </InputAdornment>
                            ),
                          }}
                          InputLabelProps={{
                            classes: { root: classes.textField }
                          }} />
                      </Box>

                      { ((otpApiData.warningCode == '3') && (otpApiData?.isWarningCode3Allowed)) && <Box>
                          <LightToolTip arrow placement="bottom" title={ADDITIONAL_FIELD_DISABLE_AGENCY}>
                            <Typography className={classes.fieldDisable}>Why is this field disabled?</Typography>
                          </LightToolTip> 
                        </Box> }
                      </Box>

                      {otpApiData.isEscrowAllowed && <Box className={classes.inputContainer}>
                        <TextField
                          color='primary'
                          id="outlined-loanNumber"
                          label="Additional Escrow Amount"
                          variant="outlined"
                          type="text"
                          value={`${additionalPayAmount.escrowAmount}`}
                          onChange={(event) => handleAdditionalPayChange(event, 'escrowAmount')}
                          fullWidth
                          className={`${classes.inputStyle} ${classes.pl20}`}
                          classes={{
                            root: classes.additionalPayTextField
                          }}
                          InputProps={{
                            classes: { root: classes.textField },
                            startAdornment: (
                              <InputAdornment position="start">
                                <AttachMoneyIcon />
                              </InputAdornment>
                            ),
                          }}
                          InputLabelProps={{
                            classes: { root: classes.textField }
                          }} />
                      </Box>}
                     </>

                  </Box> 
                </Box>
              </Box> */}

              <Box className={`${classes.additionPayment}`}>
                <Box className={`${classes.paymentDetails} ${classes.ptPhone0}`} ref={addBankRef}>
                  <Typography className={classes.otpSubHeading}>
                     Bank & Payment Details
                  </Typography>
                  {bankName.length !== 0 && 
                    <><Typography className={classes.bankAccount}>Bank Name: <span>{decrypt(bankName[0]?.bankName)}</span></Typography>
                    <Typography className={classes.bankAccount}>Account Number: <span>{maskAccountNo(decrypt(bankName[0]?.bankAccountNumber))}</span></Typography>
                    <Typography className={classes.removeBank} onClick={() => setDeleteConfirmation(true)}>
                          <CancelIcon className={classes.addPayRadioInfo} />
                      Remove Bank Account
                    </Typography></>}

                  {bankName.length == 0 && <Box className={classes.addAccLink}>
                    <Typography className={classes.addRemovePay} onClick={ToggleAccountPopup}>
                      <AddCircleIcon className={classes.addPayRadioInfo} />
                    Add Bank Account
                  </Typography>
                  </Box> }

                  {((bankNameError === '' && selectedBankError !== '') || bankName.length === 0) &&
                        <h5 className={classes.bankAccountError} style={{ textAlign: 'left', marginLeft: 0 }}>{selectedBankError}</h5>}

                  <Box className={`${classes.payCalenders} ${classes.addedAccount}`}>
                    {otpApiData !== null ? <Calender
                      selectedAccount={selectedAccount}
                      processingFee={otpApiData.processingFee.processingFee}
                      dueDate={otpApiData.paymentDueDate}
                      latePaymentDate={otpApiData.latePaymentDate}
                      updateProcessFee={updateProcessFee}
                      processNote={otpApiData.processingFee.processingFeeNote}
                      forbearanceStatus={otpApiData.forbearanceStatus}
                      propertyState={otpPaymentData.propertyState}
                      loanStatus={otpApiData.loanStatus}
                      investorCode={otpPaymentData.investorCode}
                      interestRate={otpApiData.interestRate}
                      isBPL={otpApiData.isBPL}
                      delinquentDays={otpApiData.delinquentDays}
                      graceDays={otpApiData.graceDays} 
                      warningCode={otpApiData.warningCode}
                      lstRecurACH={data?.lstRecurACH}
                      estDateTime={otpApiData.estDateTime} 
                      error={error}
                      paymentDate={paymentDate}
                      maxCalenderDate60={otpApiData?.maxCalenderDate60} 
                      paymentType={otpPaymentData.paymentType}
                      maxCalenderDate90={otpApiData?.maxCalenderDate90}
                      isPmtCalExcl={otpApiData?.isPmtCalExcl}
                      data={otpApiData} 
                      userDetails={userDetails}
                      isBKChapter13={otpApiData.isBKChapter13}
                      calenderDateCust={otpApiData.calenderDateCust}
                      /> : null}

                    {updatedProcessFee > otpApiData.processingFee.processingFee
                      && <Box className={classes.warning}>
                        <ErrorIcon style={{ color: 'red', marginRight: '8px', fontSize: '22px' }} />
                        <div ><p className={classes.colorRed}>Warning:</p>
                          <h5>Payment for this date will result in a processing fee.</h5>
                        </div>
                      </Box>}
                     
                      { ((moment(otpPaymentData.paymentDate) > moment(otpApiData.latePaymentDate)) && (moment(otpApiData.latePaymentDate) > moment(otpApiData.estDateTime))) &&
                        <Box className={classes.imageContainer}>
                          <InfoIcon className={classes.infoIcon} />
                          <Typography className={classes.paragraph}>Scheduling payment for this date will result in a late fee.</Typography>
                        </Box>
                      }
                  </Box>
                </Box>
              </Box>

            </Box>
            <Box className={`${classes.paymentDetailsBox} ${classes.posRelative}`}>
              <Box className={classes.paymentDetails}>
                <Typography className={classes.paymentHeading}>
                  Payment Details
              </Typography>

                <Box className={classes.paymentBreaks}>

                  <Box className={classes.paymentBreakBox}>
                    <Typography className={classes.bodyFont}>
                      {otpPaymentData.paymentType === 'isCustomAmount' && 'Custom Amount'}
                      {otpPaymentData.paymentType === 'Regular' && 'Regular Monthly Payment'}
                      {otpPaymentData.paymentType === 'Outstanding' && 'Total Outstanding Balance'}
                      {otpPaymentData.paymentType === 'onlyForbearance' && 'Only Forbearance Fee'}
                    </Typography>
                    <Typography className={`${classes.bodyFont} ${classes.paymentDetailsFont}`}>
                      {otpPaymentData.paymentTypeValue ? "$" + numberWithCommas(parseFloat(otpPaymentData.paymentTypeValue).toFixed(2)) : '$ 0.00'}
                    </Typography>
                  </Box>
                  <Divider orientation="horizontal" flexItem />

                   {(otpPaymentData.processingFee !== null && otpPaymentData.processingFee !== '0'
                    && otpApiData.processingFeeIsDisplay)
                    &&  <>
                    <Box className={`${classes.paymentBreakBox}`}>
                      <Typography className={classes.bodyFont}>
                        Processing Fee 
                        </Typography>
                       
                       {!mediaQuery && <LightToolTip
                            arrow placement="bottom" title={PROCESSING_FEE} >
                            <InfoIcon className={classes.processingFeeInfo}/>
                          </LightToolTip> }
                      {mediaQuery && 
                      <ClickAwayListener onClickAway={handleProcessingFeeTooltipClose}>
                        <LightToolTip
                            arrow placement="bottom" title={PROCESSING_FEE}
                            open={ openProcessingFeeTooltip }
                          >
                            <InfoIcon className={classes.processingFeeInfo} onClick={handleProcessingFeeTooltipOpen}/>
                          </LightToolTip>
                      </ClickAwayListener>}   
                      <Typography className={`${classes.bodyFont} ${classes.paymentDetailsFont}`}>
                        ${numberWithCommas(otpPaymentData.processingFee.toFixed(2))}
                      </Typography>
                    </Box>
                    
                    </>
                  }

                  {otpApiData.forbearanceApplicationFee !== 0 &&
                    <Box className={`${classes.paymentBreakBox}`}>
                      <Typography className={classes.bodyFont}>
                        Forbearance Application Fee
                      </Typography>
                      <Typography className={`${classes.bodyFont} ${classes.paymentDetailsFont}`}>
                        ${numberWithCommas(otpApiData.forbearanceApplicationFee.toFixed(2))}
                      </Typography>
                    </Box>}

                  {additionalPayAmount.principalAmount !== 0 && <Box className={`${classes.paymentBreakBox}`}>
                    <Typography className={classes.bodyFont}>
                      Additional Principal Payment
                  </Typography>
                    <Typography className={`${classes.bodyFont} ${classes.paymentDetailsFont}`}>
                      ${numberWithCommas(Number(additionalPayAmount.principalAmount).toFixed(2))}
                    </Typography>
                  </Box>}
                  {additionalPayAmount.escrowAmount !== 0 && <Box className={`${classes.paymentBreakBox}`}>
                    <Typography className={classes.bodyFont}>
                      Additional Escrow Payment
                  </Typography>
                    <Typography className={`${classes.bodyFont} ${classes.paymentDetailsFont}`}>
                      ${numberWithCommas(Number(additionalPayAmount.escrowAmount).toFixed(2))}
                    </Typography>
                  </Box>}
                </Box>

                <Box className={classes.paymentTotalBox}>
                  <Box className={`${classes.paymentTotal} ${classes.paymentBreakBox}`}>
                    <Typography className={classes.bodyFont} style={{ fontWeight: '600' }}>
                      Payment Total
                  </Typography>
                    <Typography className={`${classes.bodyFont} ${classes.paymentDetailsTotal}`}>
                      ${numberWithCommas(totalPayment.toFixed(2))}
                    </Typography>
                  </Box>
                </Box>

                <Box>
                  <Typography className={`${classes.otpSubHeading} ${classes.termNCon}`}>
                    Authorization
                </Typography>

                  <Box className={`${classes.termNConitionBox} `}>
                    <Box className={classes.tncTextContainer}>
                      <TermAndConditions data={tncSummary} ref={componentRef} />
                    </Box>
                  </Box>

                  <Box p={1} textAlign="right" className={classes.printButton}>
                    <Box p={1} textAlign="right" className={classes.printButton}>
                      <ReactToPrint
                        trigger={() => <Box className={classes.printBtnIcon}>
                          Print Form
                        <PrintIcon style={{ fill: '#535D6D', fontSize: 25, marginLeft: "5px", }} />
                        </Box>}
                        content={() => componentRef.current}
                      />
                    </Box>
                  </Box>

                </Box>
               
              
                <Box className={classes.btns}>
                  {draftOTPError !== '' && totalPayment <= otpApiData.maxPaymentAllowed && <h5 className={classes.errorMsg}>{draftOTPError}</h5>}

                  {totalPayment > otpApiData.maxPaymentAllowed && 
                  <h5 className={classes.errorMsg}>
                    Payment Amount Restricted: Total payment amount can not be greater than ${numberWithCommas(otpApiData.maxPaymentAllowed)}.<p className={classes.errorMsg2}> To complete a payment greater than ${numberWithCommas(otpApiData.maxPaymentAllowed)}, please contact Customer Support.</p></h5> 
                  }

                  {totalPayment <= otpApiData.maxPaymentAllowed && otpPaymentData.principalAmount >= otpApiData.unpaidPrincipalBalance && !otpApiData.isBKChapter13 &&
                  <>
                  <Box className={classes.errorMsg}>
                  <h5> The amount you’ve designated is greater than your principal balance.</h5>
                  <h5 className={classes.errorMsg1}>Please select <a style={{color: 'blue', cursor: 'pointer'}} onClick={() => setAccountRequired(true)}>Request Payoff</a> if you intend to pay off your loan. The instructions regarding submission of funds to satisfy your loan in full will be outlined in the payoff statement. Please note that we cannot accept a payoff online.</h5>
                  </Box>
                  </>
                   } 
                  <Button className={classes.paymentBtn}
                        onClick={() => callDebounce()}
                        disabled={disablePaymentButton || (otpApiData.isPaymentAllowed === false || (totalPayment > otpApiData.maxPaymentAllowed || otpPaymentData.principalAmount >= otpApiData.unpaidPrincipalBalance))}
                        type='submit' size="large" variant="contained" color="primary">
                        {makePayLoading ? <CircularProgress color='inherit' size={20} /> :  'REVIEW & CONTINUE'}
                  </Button> 
                </Box>
              </Box>
            </Box>
          </Grid>
         </> :
        goToHomePage && <Box className={classes.paymentAckFooterSection}>
              <Button
                className={classes.homePageBtn}
                variant="contained"
                onClick={() => props.handleStep()}
                color="primary">
                 Go to HomePage
              </Button>               
          </Box>
        }
        </div>

        {showPopup ? <AddEditAccount
          newAddedBank={newAddedBankAccount}
          toggleOpen={ToggleAccountPopup}
          open={showPopup}
          bankAccounts={bankName}
          addedAcc={addedNewAccount}
          renderPage={'oneTime'}
          userDetails={userDetails}
        /> : null}

        {
          isAlertOpen &&
          <AdditionalPaymentAlert open={true} handleCloseAlert={handleCloseAlert} routeToRequestPayOff={routeToRequestPayOff} handleClose={handleClose}
          single={true} type="quickpay"/>
        }

        { reviewPopupStatus &&
          <ReviewPayment paymentData={otpPaymentData} bankData={selectedBank} handleContinueReviewPopup={handleContinueReviewPopup} handleCloseReviewPopup={handleCloseReviewPopup} totalPayment={totalPayment} />
        }

         <FinancialHardshipAlert
            handleClose={handleFinancialHardshipAlertClose}
            open={open}
        />

        {showRestrictionPopup && <PaymentRestrictionAlert handleOkBtn={handleOkBtn} date={moment((otpPaymentData?.paymentType == 'Regular') ? otpApiData?.maxCalenderDate60 : otpApiData?.maxCalenderDate90).format('MM/DD/YYYY')} isPmtCalExcl={otpApiData?.isPmtCalExcl} isBKChapter13={otpApiData.isBKChapter13}
        showCustom={showCustom} custDate={moment(props?.calenderDateCust).format('MM/DD/YYYY')}/>}
        
        {accountRequiredPopup && <AccountRequired handleClose={() => setAccountRequired(false)}/>}
        {bankDetailsDelete && <DeleteConfirmation handleSubmitClose={() => setDeleteConfirmation(false)} handleSubmit={() => removeBankAccount()}/>}
        {showCutOffPopup && <CutOffAlert handleCutOffBtn={() => setCutOffPopup(false)}/>}
        {serviceTransferPopup && <ServiceTransferAlert transferData={otpApiData} closeServiceTransferPopup={() => setServiceTransferPopup(false)} show={false}/>}  
        {customAlertPopup && !otpApiData.isBKChapter13 && <CustomAmountAlert closeCustomeAlert={() => setCustomAlertPopup(false)}/>}
        {paymentAmtRestriction && <PaymentAmountRestriction handleClose={() => setPaymentAmtRestriction(false)}/>}

      </Box >
    )
  }
  return (
      <Box className={classes.spinner}>
        <img src={spinner} alt="spinner"/>
        <Typography className={classes.processing}>Processing</Typography>
        <Typography className={classes.refresh}>Please do not refresh the page or click the “Back” or “Close” button of your browser</Typography>
      </Box>
  )
}
